import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
const AuthRoutes = () => {
    const token = useSelector(state => state?.userData?.access_token)

    if (!token) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}
export default AuthRoutes;